module.exports = __webpack_public_path__ + "static/media/gmail.33c948e4.svg";